import React from 'react';
import { useToastContext } from '../../shared/ToastContext';
import { useMutation } from '@apollo/react-hooks';
import { GRANT_ACCESS_TIKTOK_PRODUCT_TEMPLATE } from '../../../graphql/mutations';
import { arrInvalid, handleError, reducerFn } from '../../../helper';
import { Modal } from '@shopify/polaris';
import TeamMemberSelect from '../../team-member/components/team-member-select';
import { TEAM_ROLE } from '../../../variable';
import { useSelectRowsCtx } from '../../shared/SelectRow';
import { useProductTemplateAccessLevel } from './product-template-access-level-ctx';

export default function ProductTemplateUserAccessGrant({
  open,
  onClose,
}) {
  const [state, setState] = React.useReducer(reducerFn, {
    userIds: [],
  });

  const { setNotify, toggleToast } = useToastContext();
  const { ids, onCompleted } = useSelectRowsCtx();
  const { refetch } = useProductTemplateAccessLevel();

  const [grantAccess, { loading: loadingGrant }] = useMutation(
    GRANT_ACCESS_TIKTOK_PRODUCT_TEMPLATE,
    {
      onCompleted: () => {
        onClose && onClose();
        setNotify({
          msg: "Grant access this template for user success",
          err: false,
        });

        onCompleted && onCompleted();
        refetch && refetch();
      },
      onError: (err) => {
        setNotify({ msg: handleError(err?.toString()), err: true });
      },
    },
  );

  const handleSubmit = React.useCallback(() => {
    if (arrInvalid(ids)) return;

    toggleToast && toggleToast(true);
    setNotify && setNotify({ msg: null, err: false });

    grantAccess({
      variables: {
        ids,
        userIds: state.userIds,
      },
    });
  }, [grantAccess, toggleToast, setNotify, state.userIds, ids]);

  const handleValuesChange = React.useCallback((val) => {
    setState({ userIds: val });
  }, []);

  React.useEffect(
    () => () => {
      setState({ userIds: [] });
    },
    [],
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      sectioned
      large
      title="Share product template"
      primaryAction={{
        content: "Submit",
        onAction: handleSubmit,
        loading: loadingGrant,
      }}
      secondaryActions={[{ content: "Cancel", onAction: onClose }]}
    >
      <TeamMemberSelect
        label="Users"
        allowMultiple
        value={state.userIds}
        onChange={handleValuesChange}
        getValueImmediate
        filter={{
          roles: [
            TEAM_ROLE.Admin,
            TEAM_ROLE.MarketplaceManager,
            TEAM_ROLE.StoreManager,
          ],
        }}
      />
    </Modal>
  );
}